import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconReportSimilarity } from '../../public/images/svg/icon_report_similarity.svg';
import Button from '../Button/Button';
import { SIMILARITY } from './enum';

const SimilarityChecker = ({ items = [], onClick }) => {
  if (items.length <= 0) {
    return null;
  }

  return (
    <div className="flex gap-1" data-testid="generated-prompt-similarity-checker">
      {items.map((item) => {
        const { bgColor, icon } = SIMILARITY[item.similarityScore];
        const key = `${item.title.replace(' ', '-')}`;
        return (
          <div
            key={key}
            data-testid={`generated-prompt-similarity-checker-${key}`}
            className={` w-44 p-4 ${bgColor} flex gap-4 text-grey-400 capitalize font-medium`}
          >
            {icon}
            <span>{item.title}</span>
          </div>
        );
      })}
      <Button
        type="button"
        className="bg-transparent w-56 p-4 text-purple-200 flex gap-4 capitalize font-medium"
        name="generated-prompt-similarity-checker-report"
        onClick={onClick}
        key="generated-prompt-similarity-checker-report"
        dataTest="generated-prompt-similarity-checker-report"
        icon={<IconReportSimilarity />}
        label="Comparison Report"
      />
    </div>
  );
};

SimilarityChecker.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      classification: PropTypes.number
    })
  ),
  onClick: PropTypes.func
};

export default SimilarityChecker;
